// extracted by mini-css-extract-plugin
export default {"container":"FullPageLoader_container__wCyWg"};